import styled from "@emotion/styled";
import { Avatar, Button, Flex, mediaQueries, Typography } from "@ugc-ui/lego";

export const HEADER_HEIGHT = "72px";

export const HeaderContainer = styled(Flex)`
  flex: 0 0 72px;
  padding: 0 24px;
`;

export const HeaderLogo = styled.div`
  display: inline-block;
  cursor: pointer;
  background: transparent url("/svg/logo.svg") no-repeat center center;
  background-size: contain;
  width: 117px;
  height: 24px;
`;

export const HeaderTitle = styled(Typography)`
  ${mediaQueries.lg} {
    display: none;
  }
`;

export const LinkStyled = styled.div`
  display: flex;
  align-items: center;
  margin-right: 78px;
`;

export const CreateCompainButton = styled(Button)`
  padding: 9px 15px;
  margin-right: 24px;

  ${mediaQueries.lg} {
    & > div {
      &:first-of-type {
        margin: 0;
      }
      &:last-of-type {
        display: none;
      }
    }
  }
`;

export const AvatarStyled = styled(Avatar)``;
